export const BUSY_CONTEXT = {
  ACTION: 'action',
  FIELDS: 'fields',
};

export const setBusyContext = (state, context) => {
  state.busyContext = context;
};

export const clearBusyContext = (state) => {
  state.busyContext = null;
};
